import { render, staticRenderFns } from "./SNCBillingBoard.vue?vue&type=template&id=2002e6aa&scoped=true"
import script from "./SNCBillingBoard.vue?vue&type=script&lang=ts"
export * from "./SNCBillingBoard.vue?vue&type=script&lang=ts"
import style0 from "./SNCBillingBoard.vue?vue&type=style&index=0&id=2002e6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002e6aa",
  null
  
)

export default component.exports